import React from 'react'

import { Input, Button, TextArea } from '@driftt/tide'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createCategory, changeCategoryName, changeCategoryDescription } from 'modules/knowledgebase/actions';
import { getCategory } from 'modules/knowledgebase/selectors';

const CreateNewCategoryContent = ({actions, category, onCloseSidebar}) => (
  <div className="category-section-edit-content">
    <div className="category-section-edit-banner">
      <h2 className="category-section-edit-banner-title">Create Category</h2>
    </div>
  
    <div className="category-section-edit-actions">
      <Input
        className="category-section-edit-actions-name-input"
        type="text"
        label="Category Title"
        value={category.name}
        onChange={(e) => actions.changeCategoryName(e.target.value)}
      />
      <TextArea
        className="category-section-edit-actions-description-input"
        label="Category Description"
        text={category.description}
        onChange={actions.changeCategoryDescription}
      />
      <div className="category-section-edit-actions-buttons">
        <Button
          disabled={!category.name}
          className="category-section-edit-actions-buttons-save"
          onClick={() => {
            actions.createCategory()
            onCloseSidebar()
          }}
        >
          Create Category
        </Button>
        <Button
          className="category-section-edit-actions-buttons-cancel"
          onClick={onCloseSidebar}
        >
          Cancel
        </Button>
      </div>
    </div>
  </div>
)

const mapStateToProps = state => ({
  category: getCategory(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    createCategory,
    changeCategoryName,
    changeCategoryDescription
  }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewCategoryContent)